import { createSlice } from "@reduxjs/toolkit";

export const NotificationFilter = createSlice({
  name: "NotficationFiler",
  initialState: {
    selectedFilters: [],
  },
  reducers: {
    setSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedFilters } = NotificationFilter.actions;

export default NotificationFilter.reducer;
